<template>
  <div class="selection-header">
    <SelectionHeaderOption
      v-for="(selection, index) in selections"
      :key="index"
      :selection="selection"
      :num="index"
    />
  </div>
</template>

<script>
import SelectionHeaderOption from '@/components/header/selection_header/SelectionHeaderOption';

export default {
  name: 'SelectionHeader',
  components: { SelectionHeaderOption },
  props: ['selections']
};
</script>

<style scoped>
.selection-header {
  width:100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
</style>